import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container landing-container">
        <div className="footer-content">
          <div className="footer-logo">
            <span className="footer-logo-mark">N</span>
            <span className="logo-text">Novembr</span>
          </div>
          <div className="footer-right">
            <div className="footer-links">
              <Link to="/terms" className="footer-link">Terms</Link>
              <Link to="/privacy" className="footer-link">Privacy</Link>
              <a href="mailto:hi@novembr.dev" className="footer-link">hi@novembr.dev</a>
            </div>
            <p className="footer-copyright">
              © 2024 Novembr. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
